var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewCardLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7679 4.09036C27.2365 4.55918 27.4998 5.19495 27.4998 5.85786C27.4998 6.52077 27.2365 7.15655 26.7679 7.62536L14.3929 20.0004L26.7679 32.3754C27.2233 32.8469 27.4752 33.4784 27.4695 34.1339C27.4639 34.7894 27.2009 35.4164 26.7374 35.8799C26.2739 36.3434 25.6469 36.6064 24.9914 36.612C24.3359 36.6177 23.7044 36.3658 23.2329 35.9104L9.09036 21.7679C8.62169 21.299 8.3584 20.6633 8.3584 20.0004C8.3584 19.3375 8.62169 18.7017 9.09036 18.2329L23.2329 4.09036C23.7017 3.62169 24.3375 3.3584 25.0004 3.3584C25.6633 3.3584 26.299 3.62169 26.7679 4.09036Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewCardLeftArrow);
export default __webpack_public_path__ + "static/media/reviewCardLeftArrow.fb4bba7d3347770a42dceeb3011afdab.svg";
export { ForwardRef as ReactComponent };